<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터의 이름, 주소, 전화번호 등 센터의 기본정보를 설정합니다.</span>
        </div>

        <div class="com-table-top">
            <div class="logo-area">
                <div class="logo-box">
                    <span class="logo">
                        <img :src="data.logoUrl" alt="" />
                    </span>
                </div>
                <div class="info-box">
                    <span class="location">{{ data.centerName }}</span>
                    <span class="address">
                        {{ data.address }} {{ data.addressDetail }} /
                        {{ `${data.telNo1 || ''}-${data.telNo2 || ''}-${data.telNo3 || ''}` }}
                    </span>
                    <span v-if="data.centerType == 'M'" class="type">본사</span>
                    <span v-else class="type">지점</span>
                </div>
            </div>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <span v-for="(item, index) in submenus" :key="index">
                    <router-link :class="{ on: $route.name == item.name }" :to="{ ...item, params: { centerId } }">
                        {{ item.label }}
                    </router-link>
                </span>
            </div>
            <div style="display: flex; margin-top: 30px; flex-wrap: wrap">
                <div class="pay-card" v-for="(item, index) in cardList" :key="index">
                    <div class="flex-center">
                        <div style="flex: 1; padding-top: 5px">
                            <div class="com-btn-small" v-if="item.s_rep" style="background: #00a4e8; margin-right: 5px">
                                대표
                            </div>
                            <span>{{ item.s_card_alias }}</span>
                        </div>
                        <el-dropdown class="view-more-dropdown" @command="onClickViewMore">
                            <el-button type="primary" trigger="click" style="padding: 10px 15px">...</el-button>
                            <el-dropdown-menu>
                                <el-dropdown-item
                                    :command="`${it.type + '-' + index}`"
                                    v-for="it in item.s_rep ? selectViewMore : selectViewMoreNoRep"
                                    :key="it.type"
                                >
                                    {{ it.name }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div>{{ item.s_card_name }}({{ item.s_card_number.substr(15, 4) }}) {{ item.s_card_company }}</div>
                    <div style="margin-top: 5px">{{ item.s_validity_period }}</div>
                </div>
                <div class="pay-card flex-center add-card" style="padding: 0" @click="onAddCard">
                    <div style="text-align: center">
                        <img src="/img/icons/ic_big_plus.png" style="width: 20px" />
                        <div class="add-title" style="margin-top: 20px">간편결제 카드 추가</div>
                    </div>
                </div>
            </div>
        </template>
        <div v-show="aliasEditPop" class="layer-pop square">
            <div class="view-content small-padding" style="width: auto">
                <button class="close" @click="closeAliasEdit">
                    <span class="blind">Popup Close</span>
                </button>
                <div class="com-scroll-y">
                    <p class="pop-tit" style="font-size: 18px; margin-bottom: 15px">카드 별칭 수정</p>
                    <input
                        v-model="aliasCardName"
                        style="width: 300px"
                        placeholder="카드별칭을 입력해 주세요."
                        type="text"
                    />
                    <div class="bottom-btn" style="margin-top: 30px; padding-bottom: 0">
                        <button class="com-btn" @click="onCancelEdit">취소</button>
                        <button class="com-btn blue" @click="onConfirmEdit">확인</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="addCardPop" class="layer-pop square">
            <div class="view-content small-padding" style="width: auto">
                <button class="close" @click="closeAddCardPop">
                    <span class="blind">Popup Close</span>
                </button>
                <div class="com-scroll-y">
                    <p class="pop-tit" style="font-size: 18px; margin-bottom: 15px">카드 정보 입력</p>
                    <table class="com-table left" style="margin-top: 20px">
                        <colgroup>
                            <col style="width: 200px" />
                            <col style="width: 400px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    카드 번호
                                    <span class="require">*</span>
                                </th>
                                <td style="padding: 10px">
                                    <div class="card-number">
                                        <input
                                            ref="refCardNumber1"
                                            class="pure-input"
                                            v-model="cardNumber1"
                                            style="flex: 1"
                                            placeholder="0000"
                                            type="number"
                                            @keyup="onKeyupCardNumber($event, 1)"
                                            @keydown="onKeydown($event)"
                                        />
                                        <div style="padding: 0 10px">-</div>
                                        <input
                                            ref="refCardNumber2"
                                            class="pure-input"
                                            v-model="cardNumber2"
                                            style="flex: 1"
                                            placeholder="0000"
                                            type="number"
                                            @keyup="onKeyupCardNumber($event, 2)"
                                            @keydown="onKeydown($event)"
                                        />
                                        <div style="padding: 0 10px">-</div>
                                        <input
                                            ref="refCardNumber3"
                                            class="pure-input"
                                            v-model="cardNumber3"
                                            style="flex: 1"
                                            placeholder="0000"
                                            type="number"
                                            @keyup="onKeyupCardNumber($event, 3)"
                                            @keydown="onKeydown($event)"
                                        />
                                        <div style="padding: 0 10px">-</div>
                                        <input
                                            ref="refCardNumber4"
                                            class="pure-input"
                                            v-model="cardNumber4"
                                            style="flex: 1"
                                            placeholder="0000"
                                            type="number"
                                            @keyup="onKeyupCardNumber($event, 4)"
                                            @keydown="onKeydown($event)"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>카드명/카드사</th>
                                <td style="padding: 10px">
                                    <input
                                        style="width: 100%"
                                        type="text"
                                        :value="`${cardName + (cardName != '' ? '/' : '') + cardCompany}`"
                                        disabled
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    유효기간
                                    <span class="require">*</span>
                                </th>
                                <td style="padding: 10px">
                                    <input
                                        v-model="validityPeriod"
                                        placeholder="MM/YY"
                                        style="width: 100%"
                                        type="text"
                                        @keyup="onKeyupValidityPeriod($event)"
                                        maxlength="5"
                                        @keydown="onKeydown($event)"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    CVC
                                    <span class="require">*</span>
                                </th>
                                <td style="padding: 10px">
                                    <input
                                        v-model="cvc"
                                        placeholder="카드 뒷면 3자리 숫자"
                                        style="width: 100%"
                                        type="number"
                                        @keyup="onKeyupCVC($event)"
                                        @keydown="onKeydown($event)"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    카드 비밀번호
                                    <span class="require">*</span>
                                </th>
                                <td style="padding: 10px">
                                    <input
                                        v-model="cardPassword"
                                        placeholder="비밀번호 앞 2자리 숫자"
                                        style="width: 100%"
                                        type="password"
                                        @keyup="onKeyupPassword($event)"
                                        @keydown="onKeydown($event)"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>카드 별칭</th>
                                <td style="padding: 10px">
                                    <input
                                        v-model="cardAlias"
                                        placeholder="카드 별칭(선택)"
                                        style="width: 100%"
                                        type="text"
                                        maxlength="8"
                                        @keydown="onKeydownOnlySpace($event)"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="com-check" style="margin-top: 5px">
                        <input
                            id="check-c1-1"
                            v-model="addCardAgree"
                            name="check-c1"
                            type="checkbox"
                            @change="checkComplete()"
                        />
                        <label for="check-c1-1" style="padding-left: 30px">
                            핏투데이케어 이용을 위한 위 결제수단 등록에 동의합니다.
                        </label>
                    </div>
                    <div class="bottom-btn" style="margin-top: 50px; padding-bottom: 0">
                        <button class="com-btn" @click="onCancelAddCard">취소</button>
                        <button class="com-btn blue" @click="onCompleteAddCard" :disabled="!addCardEnable">완료</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
import { Utils } from '@/assets/js/utils';
import axios from 'axios';

export default {
    name: 'SettingCenterPaymentMethod',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
    },
    props: [],
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    watch: {},
    created() {},
    mounted() {
        this.init();
    },
    data() {
        return {
            centerId: 0,

            data: {},
            submenus: [
                { name: 'SettingCenterEdit', label: '기본정보' },
                { name: 'SettingCenterProgram', label: '프로그램 가입내역' },
                { name: 'SettingCenterHoliday', label: '휴일설정' },
                { name: 'SettingCenterAccount', label: '정산설정' },
                { name: 'SettingCenterPaymentList', label: '결제내역' },
                { name: 'SettingCenterPaymentMethod', label: '결제수단' },
                { name: 'SettingCenterFitpay', label: '핏페이' }, // TESTING ON PROD
                // { name: 'SettingCenterLecture', label: 'Cross lesson settings' },
            ],

            selectViewMore: [
                { type: 2, name: '별칭수정' },
                { type: 3, name: '카드삭제' },
            ],

            selectViewMoreNoRep: [
                { type: 1, name: '대표설정' },
                { type: 2, name: '별칭수정' },
                { type: 3, name: '카드삭제' },
            ],

            cardList: [],

            isLoading: false,

            aliasEditPop: false,
            aliasCardName: '',

            addCardPop: false,
            cardNumber1: '',
            cardNumber2: '',
            cardNumber3: '',
            cardNumber4: '',
            cardName: '',
            cardCompany: '',
            validityPeriod: '',
            cvc: '',
            cardPassword: '',
            cardAlias: '',
            addCardEnable: false,
            addCardAgree: false,

            selectedCardId: 0,
        };
    },
    methods: {
        // 초기화
        async init() {
            this.centerId = parseInt(this.cId); // 센터id

            this.isLoading = true;
            if (!this.centerId) return;
            api.get(`/admin/api/center/${this.centerId}`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                    let telNo = [];
                    if (this.data.telNo.length === 8) {
                        //전화번호가 8글자일경우 적용됨(21.03.17)
                        telNo = this.data.telNo.match(/(\d{4})(\d{4})/);
                        telNo = ['', ...telNo];
                    } else if (this.data.telNo.indexOf('02') === 0) {
                        telNo = (this.data.telNo || '').match(/(\d{2})(\d{3,4})(\d{4})/);
                    } else if (this.data.telNo.length === 10) {
                        telNo = (this.data.telNo || '').match(/(\d{3})(\d{3})(\d{4})/);
                    } else {
                        telNo = (this.data.telNo || '').match(/(\d{3})(\d{4,4})(\d{4})/);
                    }

                    if (telNo) {
                        this.data.telNo1 = telNo[1];
                        this.data.telNo2 = telNo[2];
                        this.data.telNo3 = telNo[3];
                        this.data.telNo = telNo;
                    }

                    this.data.faxNo = (this.data.faxNo || '').match(/(\d{2,3})(\d{3,4})(\d{4})/);
                    if (this.data.faxNo) {
                        this.data.faxNo1 = this.data.faxNo[1];
                        this.data.faxNo2 = this.data.faxNo[2];
                        this.data.faxNo3 = this.data.faxNo[3];
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    this.data = {};
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });

            this.getPaymentMethodList();

            this.isLoading = false;
        },

        onAddCard() {
            this.showAddCardPopup();
        },

        onClickViewMore(command) {
            const data = command.split('-');
            if (data[0] == 1) {
                this.setRepresentative(data[1]);
            } else if (data[0] == 2) {
                this.aliasCardName = this.cardList[data[1]].s_card_alias;
                this.selectedCardId = this.cardList[data[1]].s_id;
                this.showAliasEditPopup();
            } else if (data[0] == 3) {
                this.onDeleteCard(data[1]);
            }
        },

        async onDeleteCard(index) {
            if (confirm('카드를 삭제하시겠습니까?')) {
                try {
                    this.isLoading = true;

                    const response = await api.delete(
                        `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/payment/method/${this.cardList[index].s_id}`
                    );
                    if (response && response.data) {
                        this.cardList = response.data;
                    }

                    this.isLoading = false;
                } catch (error) {
                    this.isLoading = false;
                    console.log(error);
                }
            }
        },

        async setRepresentative(index) {
            try {
                this.isLoading = true;

                const response = await api.put(
                    `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/payment/method/rep`,
                    {
                        id: this.cardList[index].s_id,
                    }
                );
                if (response && response.data) {
                    this.cardList = response.data;
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        showAliasEditPopup() {
            this.aliasEditPop = true;
        },

        closeAliasEdit() {
            this.selectedCardId = 0;
            this.aliasEditPop = false;
        },

        onCancelEdit() {
            this.closeAliasEdit();
        },

        async onConfirmEdit() {
            try {
                this.isLoading = true;

                const response = await api.post(
                    `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/payment/method/${this.selectedCardId}`,
                    {
                        cardAlias: this.aliasCardName == '' ? '카드명' : this.aliasCardName,
                    }
                );
                if (response && response.data) {
                    this.cardList = response.data;

                    this.closeAliasEdit();
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        initAddCardPopup() {
            this.cardNumber1 = '';
            this.cardNumber2 = '';
            this.cardNumber3 = '';
            this.cardNumber4 = '';

            this.cardName = '';
            this.cardCompany = '';
            this.validityPeriod = '';
            this.cvc = '';
            this.cardPassword = '';
            this.cardAlias = '';
            this.addCardAgree = false;
        },

        showAddCardPopup() {
            this.initAddCardPopup();

            this.addCardPop = true;
        },

        closeAddCardPop() {
            this.addCardPop = false;
        },

        onCancelAddCard() {
            this.closeAddCardPop();
        },

        async getPaymentMethodList() {
            try {
                this.isLoading = true;

                const response = await api.get(
                    `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/payment/method`
                );
                if (response && response.data) {
                    this.cardList = response.data;
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async onCompleteAddCard() {
            if (!confirm('카드를 등록하시겠습니까??')) {
                return;
            }

            const { data } = await api.post(
                `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/payment/method`,
                {
                    id: 0,
                    cardNumber:
                        this.cardNumber1 + '-' + this.cardNumber2 + '-' + this.cardNumber3 + '-' + this.cardNumber4,
                    cardName: this.cardName,
                    validityPeriod: this.validityPeriod,
                    cvc: this.cvc,
                    cardPassword: this.cardPassword,
                    cardAlias: this.cardAlias == '' ? '카드명' : this.cardAlias,
                    cardCompany: this.cardCompany,
                }
            );

            if (data) {
                alert('카드가 등록되었습니다.');

                this.getPaymentMethodList();

                this.closeAddCardPop();
            }
        },

        onKeydown(event) {
            if (
                !(
                    (event.keyCode >= 96 && event.keyCode <= 105) ||
                    (event.keyCode >= 48 && event.keyCode <= 57) ||
                    event.keyCode == 8
                )
            ) {
                return event.preventDefault();
            }
        },

        onKeydownOnlySpace(event) {
            if (event.keyCode == 32) {
                return event.preventDefault();
            }
        },

        onKeyupCardNumber(event, index) {
            this.cardName = '';
            this.cardCompany = '';

            if (index == 1) {
                if (this.cardNumber1.toString().length > 4) {
                    this.cardNumber1 = this.cardNumber1.toString().substr(0, 4);
                    this.cardNumber2 = event.key;
                    this.$refs.refCardNumber2.focus();
                }
            } else if (index == 2) {
                if (this.cardNumber2.toString().length > 4) {
                    this.cardNumber2 = this.cardNumber2.toString().substr(0, 4);
                    this.cardNumber3 = event.key;
                    this.$refs.refCardNumber3.focus();
                }
            } else if (index == 3) {
                if (this.cardNumber3.toString().length > 4) {
                    this.cardNumber3 = this.cardNumber3.toString().substr(0, 4);
                    this.cardNumber4 = event.key;
                    this.$refs.refCardNumber4.focus();
                }
            } else if (index == 4) {
                if (this.cardNumber4.toString().length >= 4) {
                    this.cardNumber4 = this.cardNumber4.toString().substr(0, 4);
                    this.searchCompany();
                }
            }
        },

        onKeyupValidityPeriod(event) {
            if (event.key == 'Backspace') {
                return;
            }

            if (this.validityPeriod.toString().length == 1) {
                if (this.validityPeriod > 1) {
                    this.validityPeriod = 1;
                }
            } else if (this.validityPeriod.toString().length == 2) {
                if (this.validityPeriod > 12) {
                    this.validityPeriod = 12;
                }
                this.validityPeriod = this.validityPeriod + '/';
            }

            this.checkComplete();
        },

        onKeyupCVC(event) {
            if (this.cvc.length > 3) {
                this.cvc = this.cvc.toString().substr(0, 3);
            }

            this.checkComplete();
        },

        onKeyupPassword(event) {
            if (this.cardPassword.length > 2) {
                this.cardPassword = this.cardPassword.toString().substr(0, 2);
            }

            this.checkComplete();
        },

        checkComplete() {
            if (
                this.cardName.length > 0 &&
                this.cardCompany.length > 0 &&
                this.validityPeriod.length == 5 &&
                this.cvc.toString().length == 3 &&
                this.cardPassword.toString().length == 2 &&
                this.addCardAgree
            ) {
                this.addCardEnable = true;
            } else {
                this.addCardEnable = false;
            }
        },

        async searchCompany() {
            // TODO search Card Company
            this.cardName = '카드명';
            this.cardCompany = '카드사';
            this.isLoading = true;
            const cardNumber = this.cardNumber1 + this.cardNumber2;
            axios
                .get('/' + cardNumber)
                .then((data) => {
                    console.log(data);
                    this.isLoading = false;
                    this.cardName = data.data.scheme;
                    this.cardCompany = data.data.bank.name;
                    this.checkComplete();
                })
                .catch((res) => {
                    this.isLoading = false;
                });

            // const { data } = await api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/payment/method`, {
            //   cardNumber: this.cardNumber1 + "-" + this.cardNumber2 + "-" + this.cardNumber3 + "-" + this.cardNumber4,
            // });
            //
            // if (data) {
            //   this.checkComplete();
            // }
        },
    },
};
</script>
<style lang="scss"></style>
